<template>
  <vue-modal
    :modal-title="$t('pages.payroll.sign_title')"
    :show-spinner="isLoading"
    :show-modal="showModal"
    :primary-footer-button-translation="$t('pages.payroll.sign_send')"
    :secondary-footer-button-translation="$t('pages.payroll.sign_undo')"
    :loading-primary-footer-button="isLoading"
    @[primaryEvent]="onPrimaryButtonClicked"
    @[secondaryEvent]="onSecondaryButtonClicked"
    @[closeEvent]="onCloseButtonClicked"
    @shown="onModalShown"
    @hidden="onModalHidden"
  >
    <template #body>
      <div class="sign-pad-wrap">
        <VueSignaturePad
          v-if="padReady"
          id="signature"
          width="100%"
          height="220px"
          ref="signaturePad"
          :options="options"
        />
      </div>
    </template>
  </vue-modal>
</template>

<script>
import VueModal, {
  CLOSE_BUTTON_CLICKED_MODAL_EVENT,
  PRIMARY_BUTTON_CLICKED_MODAL_EVENT,
  SECONDARY_BUTTON_CLICKED_MODAL_EVENT,
} from "@/components/modal";
import { SHOW_SIGN_MODAL_EVENT, PAYROLL_SIGNED_EVENT } from "./index";
import api from "@/api/payroll";

export default {
  name: "SignPayrollModal",
  components: {
    VueModal,
  },
  data() {
    return {
      isLoading: false,
      showModal: false,
      padReady: false,
      postedNumber: "",
      options: {
        penColor: "#111827",
        backgroundColor: "rgb(255, 255, 255)",
      },
    };
  },
  created() {
    EventBus.listen(SHOW_SIGN_MODAL_EVENT, ({ postedNumber }) => {
      this.postedNumber = postedNumber;
      this.showModal = true;
    });
  },
  beforeDestroy() {
    EventBus.off(SHOW_SIGN_MODAL_EVENT);
  },
  computed: {
    primaryEvent() {
      return PRIMARY_BUTTON_CLICKED_MODAL_EVENT;
    },
    secondaryEvent() {
      return SECONDARY_BUTTON_CLICKED_MODAL_EVENT;
    },
    closeEvent() {
      return CLOSE_BUTTON_CLICKED_MODAL_EVENT;
    },
  },
  methods: {
    onModalShown() {
      // Mount pad only when the Bootstrap modal is fully visible so the canvas
      // gets a real size (offsetWidth is 0 while display:none).
      this.padReady = true;
      this.$nextTick(() => {
        if (this.$refs.signaturePad && this.$refs.signaturePad.resizeCanvas) {
          this.$refs.signaturePad.resizeCanvas();
        }
      });
    },
    onModalHidden() {
      this.padReady = false;
    },
    async onPrimaryButtonClicked() {
      try {
        this.isLoading = true;
        const { isEmpty, data } = await this.$refs.signaturePad.saveSignature();

        if (!isEmpty) {
          await api.sendSign({ sign: data, postedNumber: this.postedNumber });
          EventBus.fire(PAYROLL_SIGNED_EVENT, { postedNumber: this.postedNumber });
        }
      } catch (error) {
        console.error(error);
      }
      this.isLoading = false;
      this.showModal = false;
    },
    onSecondaryButtonClicked() {
      this.clear();
    },
    onCloseButtonClicked() {
      this.showModal = false;
    },
    clear() {
      if (this.$refs.signaturePad) {
        this.$refs.signaturePad.undoSignature();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.sign-pad-wrap {
  overflow: hidden;
  border: 1px dashed var(--portal-border);
  border-radius: 14px;
  background: #fff;
  touch-action: none;
  cursor: crosshair;

  ::v-deep canvas {
    display: block;
    width: 100% !important;
    height: 220px !important;
    touch-action: none;
  }
}
</style>
